module.exports = __webpack_public_path__ + "static/media/3.a96711d2.svg";